<template>
    <div class="warning-top-wrapper d-flex flex-column aling-items-end">
        <div class="position-relative">
            <div class="position-absolute" style="right: 0;">
                <Warning
                    v-for="(item, index) in this.$store.getters.get_warnings_list" :key="index"
                    class="warning-margin"
                    :warningType="item.warningType"
                    :warningText="item.warningText"
                    @close="this.removeWarning(index)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Warning from '@/components/service/Warning';

export default {
    components : {
        Warning
    },
    methods: {
        removeWarning(index) {
            this.$store.commit("REMOVE_WARNING", index); 
        }
    }
}
</script>

<style lang="scss" scoped>
    .warning-top-wrapper {
        position: fixed;
        z-index: 4000;
        margin-top: 15px;
        left: 0;
        top: 0;
        height: 1px;
        width: 100%;
    }
  
    .warning-margin {
        margin-bottom: 20px;
    }
</style>